"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Philae = void 0;
const env_1 = require("../../conf/env");
const base_api_1 = require("./base-api");
/**
 * @description api services for Philae endpoints
 *
 * @export
 * @class Philae
 * @extends {BaseApi<T>}
 * @template T
 */
class Philae extends base_api_1.BaseApi {
    /**
     *Creates an instance of Philae.
     * @param {*} authorizationToken
     * @param {*} domainPermissionToken
     * @memberof Philae
     */
    constructor(authorizationToken) {
        const axiosConfig = {
            baseURL: env_1.PHILAE_BASE,
            // create headers object
            headers: {
            // any extra header properties can be places here.
            },
            timeout: 10000
        };
        if (authorizationToken) {
            axiosConfig.headers.Authorization = `Bearer ${authorizationToken}`;
        }
        super(axiosConfig);
    }
}
exports.Philae = Philae;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGhpbGFlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3ByaXZhdGUvYXBpLXNlcnZpY2VzL3BoaWxhZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSx3Q0FBNkM7QUFDN0MseUNBQXFDO0FBRXJDOzs7Ozs7O0dBT0c7QUFDSCxNQUFhLE1BQVUsU0FBUSxrQkFBVTtJQUN2Qzs7Ozs7T0FLRztJQUNILFlBQVksa0JBQWtCO1FBQzVCLE1BQU0sV0FBVyxHQUF1QjtZQUN0QyxPQUFPLEVBQUUsaUJBQVc7WUFDcEIsd0JBQXdCO1lBQ3hCLE9BQU8sRUFBRTtZQUNQLGtEQUFrRDthQUNuRDtZQUNELE9BQU8sRUFBRSxLQUFLO1NBQ2YsQ0FBQztRQUVGLElBQUksa0JBQWtCLEVBQUU7WUFDdEIsV0FBVyxDQUFDLE9BQU8sQ0FBQyxhQUFhLEdBQUcsVUFBVSxrQkFBa0IsRUFBRSxDQUFDO1NBQ3BFO1FBRUQsS0FBSyxDQUFDLFdBQVcsQ0FBQyxDQUFDO0lBQ3JCLENBQUM7Q0FDRjtBQXZCRCx3QkF1QkMifQ==